import {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { DropDown } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";
import { useBoardProvider } from "../../contexts/board/boardContext";
import taskService from "../../data/api/taskService";

export const DueDateYearFromTo = forwardRef(({ change }, ref) => {
  const { t, i18n } = useTranslation(["RolloverTasksModal"]);
  const { currentBoardId } = useBoardProvider();
  const { getTasksYears } = taskService();

  const [fromYears, setFromYears] = useState([]);
  const [toYears, setToYears] = useState([]);

  const fields = {
    text: "Year",
    value: "Id",
  };

  const fromYearRef = useRef(null);
  const toYearRef = useRef(null);

  const fetchTasksYears = useCallback(
    (taskTypeId) => {
      getTasksYears(currentBoardId, taskTypeId).then((response) => {
        setFromYears(response.data);
      });
    },
    [currentBoardId, getTasksYears]
  );

  const handleFromYearChange = (e) => {
    fromYearRef.current?.setShowError(false);
    change?.(e);

    //set toYears to a list of the consecutive years after the fromYear and add one year to the current one
    const fromYearVal = fromYearRef.current?.getValue();
    if (fromYearVal) {
      setToYears([fromYearVal + 1]);
    }
  };

  useImperativeHandle(
    ref,
    () => ({
      getFromYearValue: () => fromYearRef?.current?.getValue(),
      getToYearValue: () => toYearRef?.current?.getValue(),
      getFromYearComponent: () => fromYearRef.current,
      getToYearComponent: () => toYearRef.current,
      getTasksYears: fetchTasksYears,
    }),
    [fromYearRef, toYearRef, fetchTasksYears]
  );

  return (
    <div className="tax-year-content">
      <div className="m-3">{t("DueDateYearFromTo.Header")}</div>
      <div className="d-flex gap-3 m-3">
        <div className="col">
          <DropDown
            ref={fromYearRef}
            id="from-year-content"
            label={t("DueDateYearFromTo.From")}
            name="YearFrom"
            dataSource={fromYears}
            fields={fields}
            locale={i18n?.language}
            sortOrder="Descending"
            change={handleFromYearChange}
          />
        </div>
        <div className="col">
          <DropDown
            ref={toYearRef}
            id="to-year-content"
            label={t("DueDateYearFromTo.To")}
            name="YearTo"
            dataSource={toYears}
            fields={fields}
            locale={i18n?.language}
            change={(e) => {
              toYearRef.current?.setShowError(false);
              change?.(e);
            }}
            sortOrder="Descending"
          />
        </div>
      </div>
    </div>
  );
});
